/** 修改审批流程的权限码，和后端、权限注册表一致；页面访问码 `approval.flow:access` 写在菜单和路由里。 */
export const APPROVAL_UPDATE_PERMISSION = "approval.flow:update";

export const approvalSettingsQueryKey = ["approval", "settings"] as const;
export const approvalMemberCandidatesQueryKey = ["approval", "member-candidates"] as const;
export const approvalSettlementSuppliersQueryKey = ["approval", "settlement-suppliers"] as const;

/** 一条流程最多几级、每级最多几人，与后端校验一致。 */
export const MAX_FLOW_STEPS = 10;
export const MAX_STEP_MEMBERS = 20;

/** 最多几条分支，与后端分支序号 1～3 一致。 */
export const MAX_BRANCHES = 3;

/** 打开之后别人改过同一种类型时，后端返回的冲突码。 */
export const APPROVAL_SETTINGS_CONFLICT_CODE = "APPROVAL_SETTINGS_VERSION_CONFLICT";

export const approvalRoundsQueryKey = ["approval", "rounds"] as const;
export const approvalRoundDetailQueryKey = ["approval", "round-detail"] as const;

/** 待我审批、我已审批每页条数。 */
export const APPROVAL_ROUNDS_PAGE_SIZE = 20;

/** 这一级已被别人处理、这一轮已结束时后端返回的冲突码；收到后刷新列表和详情。 */
export const APPROVAL_STEP_HANDLED_CODE = "APPROVAL_STEP_HANDLED";
export const APPROVAL_ROUND_CLOSED_CODE = "APPROVAL_ROUND_CLOSED";

/** 不是这张单子或这一级的审批人时后端返回的码。 */
export const APPROVAL_NOT_APPROVER_CODE = "APPROVAL_NOT_APPROVER";

/**
 * 待我审批详情里打开业务单的链接，按审批类型配：只有登记了的类型出链接，地址用业务单号（提交审批时业务方给的单据 ID）拼。
 * 审批模块因此不用依赖各业务模块；业务单能不能看由业务模块的接口自己判断。
 */
export const APPROVAL_BUSINESS_LINKS: ReadonlyMap<string, { label: string; path: (businessId: string) => string }> = new Map([
  ["finance.payment_request", { label: "查看请款单", path: (businessId: string) => `/finance/payment-requests/${encodeURIComponent(businessId)}` }],
]);
